/** @format */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "search",
})
export class SearchPipe implements PipeTransform {
  transform(items: any[], filter: string): any {
    if (!items || !filter) {
      return items;
    } else {
      return items.filter(
        (item) =>
          (item.USER_ID && item.USER_ID.includes(filter)) ||
          (item.USER_NM && item.USER_NM.includes(filter)) ||
          (item.Company && item.Company.includes(filter))
      );
    }
  }
}
